export default __webpack_public_path__ + "static/media/headphones.d34d6a18.svg";